import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";

export const CreateAccountAction = ({ onNavigate }) => {
  return (
    <div className="loginModal-signup">
      <div className="loginOr-divider">
        <span>or</span>
      </div>
      <div className="button-effect">
        <Link to={PAGES.SIGNUP} className="btn btn-products btn-unavailable" onClick={onNavigate}>
          Create an Account
        </Link>
      </div>
    </div>
  );
};
